import { ChainId } from '@babydogeswap/sdk'

interface Contracts {
  [key: string]: {
    [ChainId.MAINNET]: string,
    [ChainId.TESTNET]: string
    [ChainId.ETHEREUM_MAINNET]?: string
    [ChainId.POLYGON_TESTNET]?: string
    [ChainId.POLYGON_MAINNET]?: string
    [ChainId.ARBITRUM_TESTNET]?: string
  }
}

export const contracts: Contracts =  {
  multiCall: {
    [ChainId.MAINNET]: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    [ChainId.TESTNET]: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
    [ChainId.ETHEREUM_MAINNET]: '0x9695fa23b27022c7dd752b7d64bb5900677ecc21',
    [ChainId.POLYGON_TESTNET]: '0xe9939e7Ea7D7fb619Ac57f648Da7B1D425832631',
    [ChainId.POLYGON_MAINNET]: '0x275617327c958bD06b5D6b871E7f491D76113dd8',
    [ChainId.ARBITRUM_TESTNET]: '0x108B25170319f38DbED14cA9716C54E5D1FF4623'
  },
  babyDogeProfile: {
    [ChainId.MAINNET]: '0xf5a2Cb466Fa1BC037A463a53d5f889D9C86EDD69',
    [ChainId.TESTNET]: '0xBf17767f5Ad0f96B581C145ED1605a92Cd3AaE95'
  },
  claimRefund: {
    [ChainId.MAINNET]: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    [ChainId.TESTNET]: ''
  },
  pointCenterIfo: {
    [ChainId.MAINNET]: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    [ChainId.TESTNET]: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3'
  },
  tradingCompetition: {
    [ChainId.MAINNET]: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    [ChainId.TESTNET]: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97'
  },
  farmAuction: {
    [ChainId.MAINNET]: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    [ChainId.TESTNET]: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe'
  },
  babyDoge: {
    [ChainId.MAINNET]: '0xc748673057861a797275cd8a068abb95a902e8de',
    [ChainId.TESTNET]: '0x28017936E4e95CcAfe2d3d89C222bF470e58965E'
  },
  TestVoteToken: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0x45a245D20Ee6ad18D04f85B2687725e033213AdA'
  },
  TreatTimelock: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0x8F20567f0133029Df75Be0f8a2EeBA42E8B14dc1'
  },
  TreatGovernor: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0x0C55Fb7190c94e2ABc91ebBDe931CAcb918D377d'
  },
  bnb: {
    [ChainId.MAINNET]: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    [ChainId.TESTNET]: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd'
  },
  BNBWrapper: {
    [ChainId.MAINNET]: '0xc7AC77Eec5AFBf589808b6b5d47e8A14Ea8c29C8',
    [ChainId.TESTNET]: '0x856091112586dD05B25553dAD72Fe948B0fECd2D'
  },
  FaasDeployer: {
    [ChainId.MAINNET]: '0x210DBF538EF70750e0eb6149005bF2d40d49D5b2',
    [ChainId.TESTNET]: '0x5d4358eaC2afc2ca6150a1d43B130c830722d5b1'
  },
  AdminFaasDeployer: {
    [ChainId.MAINNET]: '0xbB41e9798Fafa48f62fDC5F5dCB4961980F19543',
    [ChainId.TESTNET]: '0x7F5788abdBd04ff89A30D976788d359717d7D0F5'
  },
  TreatToken: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0xB3cd9e5Aaa8B5d53d002a023f9cE262d08A35D43'
  },
  TreatLiquidity: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0xb0cEb873e9B2cC11990C89528A434cB3d9d2dCdF'
  },
  TreatFlexiblePool: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0x210728D701856FFf18B8eF083B52fC73024A5125'
  },
  TreatZapAddress: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0xBfcB10984bdfc7F6A4c40bb51341964c1ca4FB07'
  },
  PeriodStaking: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0x5acb4d16c9c3eeedb5d5c083fe7e0e0ee03d0117'
  },
  tokenLocker: {
    [ChainId.MAINNET]: '0x36b34364e17373C05300Bc3e827BF7cac34541BE',
    [ChainId.TESTNET]: '0x4C8BC2c90B6831d18319ABBd7b63E3d6bBA7bb3E'
  },
  tokenLockerV2: {
    [ChainId.MAINNET]: '0x0812e74047221071efEEE00E5CdFAF0dBFE2bbC0',
    [ChainId.TESTNET]: '',
    [ChainId.ETHEREUM_MAINNET]: '0xa03527a3aDC599d22bdefee0F2128bA81BFC7b2B',
    [ChainId.POLYGON_TESTNET]: '0xE009980226233Ff3Fc8D96ed466028B9b73ae52e',
    [ChainId.POLYGON_MAINNET]: '0xB322360B2aA6254348F1c7E14e9cC20D77A0bbbF',
    [ChainId.ARBITRUM_TESTNET]: '0x8adCE287716648df409fACcbBEcf76fe25C8fE22'
  },
  nftMarket: {
    [ChainId.MAINNET]: '0xf345826F723C5ACb785d23A8a197ad46d8566bb3',
    [ChainId.TESTNET]: '0x47885e005C0b60D99a36465801ef5339197B8296'
  },
  babyDogeDoggies: {
    [ChainId.MAINNET]: '0x7257E66B830441A9300e8ece6b8b1649e04016Ef',
    [ChainId.TESTNET]: '0x9f22bF4Ac6a2Ca148bFC15090F05936C220775Ad'
  },
  doggyFactory: {
    [ChainId.MAINNET]: '0xc231978220C7FFC3AAF9cEA6C22D96c001AB1A68',
    [ChainId.TESTNET]: '0x153B5046161f34dC27fd151c8E0E8daB5e754579'
  },
  BabyDogeRouter: {
    [ChainId.MAINNET]: '0xC9a0F685F39d05D835c369036251ee3aEaaF3c47',
    [ChainId.TESTNET]: '0xa18f36819023ABe64a1D811E529f6bc83fEF9572'
  },
  BabydogeLiquidityMiddleware: {
    [ChainId.MAINNET]: '0x9869674E80D632F93c338bd398408273D20a6C8e',
    [ChainId.TESTNET]: '0x6387f46Ce1B13B8d5F5Fa169EF70e818F992cdF0'
  },
  zap: {
    [ChainId.MAINNET]: '0xFF57372F16147117520D40FE777feda51B1226Ba',
    [ChainId.TESTNET]: '0x82C6b0F31bbf1f2A67c3B91D655647A6a056E4b6'
  },
  faasZap: {
    [ChainId.MAINNET]: '0x451583B6DA479eAA04366443262848e27706f762',
    [ChainId.TESTNET]: '0x001b3F13A60B25c0314cf1a219B7c6cA04A5dbB4'
  },
  migratorVersion1: {
    [ChainId.MAINNET]: '0xfB03A41e365d8471DCa8dFC40a8a1Dc13Eb61Be1',
    [ChainId.TESTNET]: '0xeeDd9890d62c0F46a4bF14017552B6D2Dc1fe521'
  },
  migratorVersion2: {
    [ChainId.MAINNET]: '0x5c588Dc96A8c916A1f76Af8a5AFBd036467621df',
    [ChainId.TESTNET]: '0x7b4C42aFAAe1E33Fa84DB4267790A9bB4552Bae0'
  },
  BurnPortal: {
    [ChainId.MAINNET]: '0xb16f1D0adcd59f32e4C443b6B9ab3F34e1f7b332',
    [ChainId.TESTNET]: '0x22fBbeb64b59B67A51e464a18cf2252CeCd3fD31'
  },
  NFTPositionManager: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0x88f52AF116658C46A658bA7d2dF34c4502dcA2CE'
  },
  MasterchefV3: {
    [ChainId.MAINNET]: '',
    [ChainId.TESTNET]: '0x2bAe9297F787C3a15e86cd86401A88d680216047'
  },
  v3Migrator: {
    [ChainId.ETHEREUM_MAINNET]: '0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2',
    [ChainId.MAINNET]: '0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2',
    [ChainId.TESTNET]: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
  },
  Masterchef: {
    [ChainId.TESTNET]: '0xB4A466911556e39210a6bB2FaECBB59E4eB7E43d',
    [ChainId.MAINNET]: '0xa5f8C5Dbd5F286960b9d90548680aE5ebFf07652',
  },
  MasterchefV1: {
    [ChainId.TESTNET]: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    [ChainId.MAINNET]: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
  },
  NonBscVault: {
    [ChainId.MAINNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841', // Only for pass contracts test
    [ChainId.ETHEREUM_MAINNET]: '0x2e71B2688019ebdFDdE5A45e6921aaebb15b25fb',
    [ChainId.TESTNET]: ''
  },
}
